export const attendanceArea = {
  Unset: 0,
  Registro: 379, //Determinación Inicial
  CambioImpedimentoRazonesEspecificas: 380,
  CambioImpedimentoEvaluaciónTrianual: 381, //Estudiante Público
  PostRegistroIIPublico: 405, //Pos Registro
  PostRegistroIIPrivado: 406, //Pos Registro
  DeterminacionProcesoTrianual: 422, //Estudiante Privado
};
